import { MonitoringTarget } from "models/monitoring-target";
import {
  axiosInstance as Repository,
  RESULT_CD,
  RepositoryError,
} from "../repository";

const RESOURCE = "/projects";

/* カスタム例外 */
class MonitoringTargetsRepositoryError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class MonitoringTargetsRepositoryStoreError extends MonitoringTargetsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class MonitoringTargetsRepositoryUpdateError extends MonitoringTargetsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class MonitoringTargetsRepositoryIndexError extends MonitoringTargetsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class MonitoringTargetsRepositoryGetError extends MonitoringTargetsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class MonitoringTargetsRepositoryDestroyError extends MonitoringTargetsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class MonitoringTargetsRepositoryImageFileUploadError extends MonitoringTargetsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

class MonitoringTargetsRepositoryDeleteImageDeleteError extends MonitoringTargetsRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

/* API Response と modelの変換 */
function getInstance(item) {
  const projectId = item.project_id;
  const monitoringTargetId = item.monitoring_target_id;
  const monitoringTarget = new MonitoringTarget(projectId, monitoringTargetId);

  monitoringTarget.organizationId = item.organization_id;
  monitoringTarget.name = item.name;
  monitoringTarget.note = item.note;
  monitoringTarget.imagePath = item.image_path;
  monitoringTarget.resizeImagePath = item.resize_image_path;
  monitoringTarget.monitoringStatusCd = item.monitoring_status_cd;
  monitoringTarget.deletedFlag = item.deleted_flag;
  monitoringTarget.version = item.version;
  monitoringTarget.resourceId = item.resource_id;
  monitoringTarget.createdAt = item.created_at;
  monitoringTarget.createdBy = item.created_by;
  monitoringTarget.updatedAt = item.updated_at;
  monitoringTarget.updatedBy = item.updated_by;
  monitoringTarget.deletedAt = item.deleted_at;
  monitoringTarget.deletedBy = item.deleted_by;

  return monitoringTarget;
}

function makeRequestJson(monitoringTarget) {
  const requestJosn = {
    organization_id: monitoringTarget.organizationId,
    name: monitoringTarget.name,
    note: monitoringTarget.note,
    image_path: monitoringTarget.imagePath,
    resize_image_path: monitoringTarget.resizeImagePath,
    monitoring_status_cd: monitoringTarget.monitoringStatusCd,
    deleted_flag: monitoringTarget.deletedFlag,
    version: monitoringTarget.version,
    resource_id: monitoringTarget.resourceId,
    created_at: monitoringTarget.createdAt,
    created_by: monitoringTarget.createdBy,
    updated_at: monitoringTarget.updatedAt,
    updated_by: monitoringTarget.updatedBy,
    deleted_at: monitoringTarget.deletedAt,
    deleted_by: monitoringTarget.deletedBy,
  };

  return requestJosn;
}

export default {

  async store(monitoringTarget) {
    const urlParams = {
      projectId: monitoringTarget.projectId,
    };
    const requestParams = makeRequestJson(monitoringTarget);
    const response = await Repository.post(`${RESOURCE}/${urlParams.projectId}/monitoring-targets`, requestParams);

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryStoreError();
    }

    return getInstance(response.data.item);
  },

  async sendCreationNotification(projectId, monitoringTargetId) {
    const urlParams = {
      projectId,
      monitoringTargetId,
    };

    const response
      = await Repository.get(`${RESOURCE}/${urlParams.projectId}/monitoring-targets/${urlParams.monitoringTargetId}/send-creation-notification`, {
        params: {},
      });

    // 処理結果のチェック
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryGetError();
    }
  },

  async update(monitoringTarget) {
    const urlParams = {
      projectId: monitoringTarget.projectId,
    };
    urlParams.monitoringTargetId = monitoringTarget.monitoringTargetId;
    const requestParams = makeRequestJson(monitoringTarget);
    const response = await Repository.put(`${RESOURCE}/${urlParams.projectId}/monitoring-targets/${urlParams.monitoringTargetId}`, requestParams);

    console.log(response.data);
    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryUpdateError();
    }

    return getInstance(response.data.item);
  },

  async index(projectId) {
    const urlParams = {
      projectId,
    };
    const response = await Repository.get(`${RESOURCE}/${urlParams.projectId}/monitoring-targets`, {
      params: {},
    });

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryIndexError();
    }

    const items = [];
    response.data.items.forEach((item) => {
      items.push(getInstance(item));
    });
    return items;
  },

  async get(projectId, monitoringTargetId) {
    const urlParams = {
      projectId,
    };
    urlParams.monitoringTargetId = monitoringTargetId;
    const response = await Repository.get(`${RESOURCE}/${urlParams.projectId}/monitoring-targets/${urlParams.monitoringTargetId}`, {
      params: {},
    });

    // 処理結果のチェック
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryGetError();
    }

    return getInstance(response.data.item);
  },

  async destroy(projectId, monitoringTargetId) {
    const urlParams = {
      projectId,
    };
    urlParams.monitoringTargetId = monitoringTargetId;
    const response = await Repository.delete(`${RESOURCE}/${urlParams.projectId}/monitoring-targets/${urlParams.monitoringTargetId}`, {
      params: {},
    });

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryDestroyError();
    }
  },

  async upsert(monitoringTarget) {
    let res = null;
    if (monitoringTarget.monitoringTargetId === null) {
      res = this.store(monitoringTarget);
    } else {
      res = this.update(monitoringTarget);
    }
    return res;
  },

  async uploadImageFile(monitoringTarget, imageFile) {
    const formData = new FormData();
    formData.append("file", imageFile);
    const urlParams = {
      projectId: monitoringTarget.projectId,
    };
    urlParams.monitoringTargetId = monitoringTarget.monitoringTargetId;
    const response = await Repository.put(`${RESOURCE}/${urlParams.projectId}/monitoring-targets/${urlParams.monitoringTargetId}/upload-image-file`, formData);
    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryImageFileUploadError();
    }

    return getInstance(response.data.item);
  },

  async deleteImageFile(monitoringTarget) {
    const urlParams = {
      projectId: monitoringTarget.projectId,
    };
    urlParams.monitoringTargetId = monitoringTarget.monitoringTargetId;
    const response = await Repository.put(`${RESOURCE}/${urlParams.projectId}/monitoring-targets/${urlParams.monitoringTargetId}/delete-image-file`);
    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryDeleteImageDeleteError();
    }

    return getInstance(response.data.item);
  },

  async updateMonitoringStatus(monitoringTarget) {
    const urlParams = {
      projectId: monitoringTarget.projectId,
    };
    const requestParams = {
      monitoring_status_cd: monitoringTarget.monitoringStatusCd,
      version: monitoringTarget.version,
    };
    urlParams.monitoringTargetId = monitoringTarget.monitoringTargetId;
    const response = await Repository.put(`${RESOURCE}/${urlParams.projectId}/monitoring-targets/${urlParams.monitoringTargetId}/update-monitoring-status`, requestParams);

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new MonitoringTargetsRepositoryUpdateError();
    }
    console.log(response);

    return getInstance(response.data.item);
  },
};
